export const getDaysString = (
  type: "visitorSummary" | "registrationSummary" | "orderSummary",
) => {
  if (type === "visitorSummary") return "visitors";
  if (type === "registrationSummary") return "registrations";
  if (type === "orderSummary") return "orders";
};
